import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectsComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    { name:"Tag Type",prop:"tagcategories_ids" },
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  

  tag_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  tag_cat_list =[]
  selected_tag_cat_id = null
  isTagCat : boolean =false

  guideline_data:any
  course_id:any
  currentUrl:any
  constructor( public apiService:ApiService,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService,private activatedRoute:ActivatedRoute) { 
                this.currentUrl=this.activatedRoute.snapshot.routeConfig.path
                if(this.currentUrl === 'student-projects/:id'){
                  this.activatedRoute.paramMap.subscribe(params => { 
                    this.user_role = params.get('id'); 
                    this.getProjectsByUser(this.user_role)
                });
                }
                if(this.currentUrl !== 'student-projects/:id'){
                  this.user_role=JSON.parse(localStorage.getItem('user')).id
                  this.course_id = localStorage.getItem('course-id')
                }

              }

  ngOnInit(): void {
    
      this.getProjectsByUser(this.user_role)
    
    
  }
  getProjectsByUser(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllProjectByStudent(id).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  filter(data){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.filterAssignment(data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.spinner.hide();
        this.rows = res?.data
        this.page.totalPages = res?.data?.length
      }
    })
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.getProjectsByUser(this.course_id.id)
  }

  pageChangeData(page:any){
    this.apiService.getAllFaqByCourse(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  
}
